import { tryWrapper } from './helpers'

export const YMGoalTelegramClick = () => tryWrapper(
  () => ym('40131035', 'reachGoal', 'telegram-click')
)
